import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import ScrollToTop from "react-scroll-to-top"
import Services from './Services'
import Aboutus from './Aboutus'
import "./Home.css";
import Product from './Product'
import YoutubeVideo from './YoutubeVideo'
import gemlogo from "../images/gem _logo.jpg";

function Home() {
    const phoneNumber = "919064797437"; // Replace with your number (with country code, no +)
    const message = "Hello..";

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${919064797437}?text=${encodedMessage}`;
  return (
    <div>
      <Navbar />
      <br />
      <br />
     
        <div className="album py-2">
          <div className="container">
            <h6>masterofsecuritysystem</h6>
            </div>
            </div>
       
      <Slider />


      <div className='securitysystem'>
        <br />
        <div className="album py-0">
          <div className="container">
            <h1 className='mb-0' style={{ color: "#0C0F77" }}><b>Our Services</b></h1>
            <p><small>we provide end-to-end security and electronic solutions to keep your home, office, shop and business fully protected and smoothly running.</small></p>
          </div>
        </div>
        <Services />
      </div>

            <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "5px" }} className="fixed-bottom  mb-1"> 
               <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
                                    <button className='whatsAppicon'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                        </svg> 
                                    </button>
                                </a>

            </div>

      <ScrollToTop smooth top="100" style={{ padding: "3px" }} color="Gray" />
      <br />

      <Aboutus />
      <br />

       <hr/>
       
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-8">
                            
                                <div className="card-body">
                                    <h1 style={{color:"#060763"}} className="card-title"><b>GEM Bid Participation & Project Execution</b></h1>
                                    <p  style={{color:"#104A3F"}} className="card-text justify">Our company actively participates in Government e-Marketplace (GeM) bids to deliver high-quality, reliable, and compliant products and services. We ensure complete transparency, timely documentation, accurate pricing, and adherence to all government procurement guidelines.</p>
                                   
                                </div>
                            
                        </div>
                         <div className="col-md-4">
                          
                                <img src={gemlogo} className="card-img-top" alt="gemlogo"/>
                                
                        </div>
                    </div>
                </div>
            </div>
             <br/>
        <YoutubeVideo/>
      <div className='securitysystem'>
        <br />
        <div className="album py-0">
          <div className="container">
            <h1 className='mb-0' style={{ color: "#0C0F77" }}><b>Our Products</b></h1>
            <p className='mb-0'><small>Quality products designed for reliability and performance.</small></p>
            <br/>
          </div>
        </div>
     
      
<Product/>
      </div>
    </div>
  )
}

export default Home